import Navigation from './modules/Navigation.js';
import MobileNavigation from './modules/MobileNavigation.js';
import MenuTracking from './modules/MenuTracking.js';
import VideoTracking from './modules/VideoTracking.js';
import FacetWP from './modules/FacetWP.js';
import Columns from './modules/Columns.js';
import Alert from './modules/Alert.js';
import EventListings from './modules/EventListings.js';
import MarketoAjaxForms from './modules/MarketoAjaxForms.js';
import TestimonialsSlider from './modules/TestimonialsSlider.js';
import SocialProofSlider from './modules/SocialProofSlider.js';
import PostSlider from './modules/PostSlider.js';
import GatedContent from './modules/GatedContent.js';
import StatCards from './modules/StatCards.js';
import FullBleedRibbon from './modules/FullBleedRibbon.js';
import Toc from './modules/Toc.js';
import CoverVideoBackground from './modules/CoverVideoBackground.js';

document.addEventListener('DOMContentLoaded', function() {
  Navigation();
  MobileNavigation();
  MenuTracking();
  VideoTracking();
  Columns();
  FacetWP();
  Alert();
  EventListings();
  MarketoAjaxForms();
  TestimonialsSlider();
  SocialProofSlider();
  PostSlider();
  GatedContent();
  StatCards();
  FullBleedRibbon();
  Toc();
  CoverVideoBackground();

  // Remove tabindex="-1" from language switcher options to make it keyboard accessible
  const languageOptions = document.querySelectorAll('.trp-language-switcher [tabindex="-1"]');
  languageOptions.forEach(option => {
      option.setAttribute('tabindex', '0');
  });

  // Make Enter key work on language options (excluding current language)
  const languageLinks = document.querySelectorAll('.trp-language-item:not(.trp-language-item__current)');
  languageLinks.forEach(link => {
      link.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.click();
          }
      });
  });

  // Add accessible name to language switcher listbox
  const languageSwitchers = document.querySelectorAll('.trp-language-switcher[role="listbox"]');
  languageSwitchers.forEach(switcher => {
      if (!switcher.hasAttribute('aria-label') && !switcher.hasAttribute('aria-labelledby')) {
          switcher.setAttribute('aria-label', 'Language switcher');
      }
  });

});
